import styled from "styled-components";
import { colorPallet } from "../../styles/global";

export const Heading = styled.h1`
  font-size: 20px;
  font-weight: 700;
  color: ${colorPallet.darkBlue};
  text-align: start;

  width: 1040px;
  margin-bottom: 40px;

  @media screen and (max-width: 1366px) {
    font-size: 18px;
  }
  @media screen and (max-width: 1097px) {
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const Header = styled.div`
  width: 100%;
  padding: 0 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
